import React, { useState, useEffect } from 'react';
import { useTabs, TabBar } from '../TabManager';
import AdminAuditLog from './AdminAuditLog';
import UserList from '../System/UserList';
import AccessReport from '../System/AccessReport';
import UserGroupList from '../System/UserGroupList';

/* دکمه‌های بخش سیستم */
const ZEMANAT_BUTTONS = [
  { key: 'btnUsers',      perm: 'users', label: 'کاربران و سطوح دسترسی', icon: '👥', bg: 'linear-gradient(135deg,#b71c1c,#c62828)', page: 'users' },
  { key: 'btnPermission', perm: 'users_permission', label: 'گزارش دسترسی‌ها',        icon: '🔐', bg: 'linear-gradient(135deg,#4a148c,#6a1b9a)', page: 'report' },
  { key: 'btnUserGroup',  perm: 'groups', label: 'گروه‌های کاربری',        icon: '🏢', bg: 'linear-gradient(135deg,#00695c,#00897b)', page: 'groups' },
  /* لاگ ممیزی فقط خواندنی است — نه ویرایش دارد نه حذف (الزام ۶ افتا) */
  { key: 'BTNAUDITLOG',   perm: 'auditlog', label: 'مشاهده لاگ ممیزی',      icon: '📋', bg: 'linear-gradient(135deg,#1a237e,#283593)', page: 'auditlog' },
];

const PAGE_COMPONENTS = {
  users:    UserList,
  report:   AccessReport,
  groups:   UserGroupList,
  auditlog: AdminAuditLog,
};

export default function AdminSystem({ user, onBack }) {
  const { openTab, goHome } = useTabs();

  const openSubPage = (btn) => {
    const Comp = PAGE_COMPONENTS[btn.page];
    if (!Comp) { alert(`صفحه "${btn.label}" در حال توسعه است`); return; }
    openTab(`system:${btn.page}`, btn.label, btn.icon, () => <Comp user={user} onBack={goHome} />);
  };

  // هر دکمه فقط با تأیید سرور دیده می‌شود (دیدن = دسترسی).
  // کاربران و گروه‌ها مجوز تب «تعاریف» و فرم خودشان را می‌خواهند؛
  // داشتن تب «سیستم» به‌تنهایی هیچ‌کدام را باز نمی‌کند. ادمین محلی همه را دارد.
  const [sp, setSp] = useState({});
  useEffect(() => { (async () => {
    try {
      const r = await fetch('/api/system/menu-permissions/', {
        headers: { Authorization: `Bearer ${localStorage.getItem('access')}` } });
      const d = await r.json();
      if (d && d.ok) setSp(d);
    } catch (e) { console.error(e); }
  })(); }, []);
  const allowedBtns = ZEMANAT_BUTTONS.filter(btn => sp[btn.perm] === true);

  const gridResponsiveCSS = `@media(max-width:640px){.arjan-acc-grid{grid-template-columns:repeat(2,1fr)!important;gap:16px!important;max-width:360px;margin:0 auto;padding:0 12px;}}`;

  return (
    <><style>{gridResponsiveCSS}</style>
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../../assets/images/arjan.png')} alt="ارجان" style={{width:'36px',height:'36px',borderRadius:'8px'}}/></div>
          <div><div style={s.hTitle}>سامانه ارجان</div><div style={s.hSub}>بخش سیستم</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>
      <main style={s.main}>
        <div style={s.hero}><div style={s.heroIcon}>⚙️</div><div><h2 style={s.heroTitle}>بخش سیستم</h2><p style={s.heroSub}>{allowedBtns.length} مورد در دسترس شما</p></div></div>
        {allowedBtns.length > 0 ? (
          <div className="arjan-acc-grid" style={s.grid}>
            {allowedBtns.map(btn => (
              <div key={btn.key} style={s.btnWrap}>
                <button style={{...s.btn,background:btn.bg}} onClick={()=>openSubPage(btn)}
                  onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-8px) scale(1.05)';e.currentTarget.style.boxShadow='0 16px 40px rgba(0,0,0,0.35)';}}
                  onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0) scale(1)';e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.2)';}}>
                  <span style={s.btnIcon}>{btn.icon}</span>
                </button>
                <div style={s.btnLabel}>{btn.label}</div>
              </div>
            ))}
          </div>
        ) : (<div style={s.noAccess}><div style={{fontSize:'56px',marginBottom:'16px'}}>🔒</div><div style={{fontSize:'16px',color:'#666'}}>دسترسی به این بخش تعریف نشده است</div></div>)}
      </main>
    </div></>
  );
}

const s = {
  page:{minHeight:'100vh',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'12px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',position:'sticky',top:0,zIndex:100},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'16px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'32px 24px',maxWidth:'1100px',margin:'0 auto'},
  hero:{display:'flex',alignItems:'center',gap:'16px',marginBottom:'32px'},
  heroIcon:{fontSize:'40px'},
  heroTitle:{fontSize:'22px',fontWeight:'800',color:'#1a2f50',margin:0},
  heroSub:{fontSize:'13px',color:'#888',margin:'4px 0 0'},
  grid:{display:'grid',gridTemplateColumns:'repeat(4,160px)',gap:'24px',justifyContent:'center'},
  btnWrap:{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'},
  btn:{width:'100%',aspectRatio:'1',border:'none',borderRadius:'20px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',transition:'all .25s'},
  btnIcon:{fontSize:'36px'},
  btnLabel:{fontSize:'13px',fontWeight:'700',color:'#333',textAlign:'center'},
  noAccess:{textAlign:'center',padding:'60px 20px'},
};
